/**
 * ページURLコピー
 */
export const COPY_URL = {
  selectors: {
    trigger: '.js-copy-url',
  },

  messages: {
    success: 'コピーしました',
    error: 'URLをコピーできませんでした。',
  },

  duration: 2000,

  init() {
    const triggers = document.querySelectorAll(this.selectors.trigger)

    if (!triggers.length) {
      return
    }

    triggers.forEach(trigger => {
      if (trigger.dataset.copyUrlInitialized === 'true') {
        return
      }

      trigger.dataset.copyUrlInitialized = 'true'

      trigger.addEventListener('click', () => {
        this.copy(trigger)
      })
    })
  },

  async copy(trigger) {
    const defaultHtml = trigger.innerHTML

    try {
      await this.writeClipboard(window.location.href)

      trigger.textContent = this.messages.success

      setTimeout(() => {
        trigger.innerHTML = defaultHtml
      }, this.duration)
    } catch (error) {
      console.error(this.messages.error, error)
    }
  },

  async writeClipboard(text) {
    if (navigator.clipboard?.writeText && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
      return
    }

    this.writeClipboardFallback(text)
  },

  writeClipboardFallback(text) {
    const textarea = document.createElement('textarea')

    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.style.cssText = 'position:fixed;top:0;left:0;opacity:0;'
    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()

    const succeeded = document.execCommand('copy')

    document.body.removeChild(textarea)

    if (!succeeded) {
      throw new Error(this.messages.error)
    }
  },
}
